import { render, staticRenderFns } from "./sort-options-selector.vue?vue&type=template&id=49783ef9&lang=pug&"
import script from "./sort-options-selector.vue?vue&type=script&lang=js&"
export * from "./sort-options-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports